// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.css
// module id = ZMjw
// module chunks = 4